// Validation rules
const rules = {
  required: (value) => ({
    isValid: value !== undefined && value !== null && value !== '',
    message: 'This field is required'
  }),

  email: (value) => ({
    isValid: value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
    message: 'Please enter a valid email address'
  }),

  minLength: (min) => (value) => ({
    isValid: value && typeof value === 'string' && value.length >= min,
    message: `Must be at least ${min} characters`
  }),

  maxLength: (max) => (value) => ({
    isValid: value && typeof value === 'string' && value.length <= max,
    message: `Must be no more than ${max} characters`
  }),

  phone: (value) => ({
    isValid: value && /^\d{10}$/.test(value),
    message: 'Phone number must be exactly 10 digits'
  }),

  number: (value) => ({
    isValid: value !== undefined && value !== null && !isNaN(parseFloat(value)) && isFinite(value),
    message: 'Must be a valid number'
  }),

  positiveNumber: (value) => ({
    isValid: value !== undefined && value !== null && parseFloat(value) > 0,
    message: 'Must be a positive number'
  }),

  password: (value) => ({
    isValid: value && typeof value === 'string' && value.length >= 6,
    message: 'Password must be at least 6 characters'
  })
};

// Common validation rules for specific fields
export const commonValidations = {
  customerName: [rules.required],
  customerPhone: [rules.required, rules.phone],
  location: [rules.required],
  productId: [rules.required],
  quantity: [rules.required, rules.number, rules.positiveNumber],
  unitPrice: [rules.required, rules.number, rules.positiveNumber],
  amount: [rules.required, rules.number, rules.positiveNumber],
  collectedBy: [rules.required],
  notes: [] // Optional field
};

// Validate a single field
const validateField = (value, fieldRules) => {
  if (!Array.isArray(fieldRules)) {
    return null;
  }

  for (const rule of fieldRules) {
    if (typeof rule !== 'function') {
      continue;
    }
    const result = rule(value);
    if (!result.isValid) {
      return result.message;
    }
  }
  return null;
};

// Validate entire form
export const validateForm = (formData, validationRules) => {
  if (!formData || typeof formData !== 'object') {
    return { submit: 'Invalid form data' };
  }

  if (!validationRules || typeof validationRules !== 'object') {
    return { submit: 'Invalid validation rules' };
  }

  const errors = {};
  
  Object.keys(validationRules).forEach(field => {
    const fieldRules = validationRules[field];
    if (Array.isArray(fieldRules) && fieldRules.length > 0) {
      const error = validateField(formData[field], fieldRules);
      if (error) {
        errors[field] = error;
      }
    }
  });
  
  return errors;
}; 